import { urlWithQuery } from '~/utils/url';
import { BaseRestRepository } from './baseRestRepository';
import type {
  GetPaginatedManagementFeesParams,
  GetManagementFeeCreditsParams,
  ManagementFeePaginationDto,
  CalculateManagementFeesDto,
  ManagementFeesResultDto,
  AddManagementFeesDto,
  ManagementFeeDto,
  ManagementFeeCreditPaginationDto,
  AddManagementFeeCreditDto,
  ManagementFeeCreditDto,
  AdjustManagementFeeCreditDto,
} from '~/swagger/portal/Api';

const BASE_URL = '/api/management-fees';

export class ManagementFeesRepository extends BaseRestRepository {
  public async getManagementFees(filter?: GetPaginatedManagementFeesParams): Promise<ManagementFeePaginationDto> {
    const url = urlWithQuery(BASE_URL, filter);
    const response = await this.fetchWithAuth(url);
    return this.getJsonResponse(response);
  }

  public async calculateManagementFees(payload: CalculateManagementFeesDto): Promise<ManagementFeesResultDto> {
    const url = `${BASE_URL}/calculate`;
    const response = await this.fetchWithAuth(url, {
      method: 'POST',
      body: JSON.stringify(payload),
    });
    return this.getJsonResponse(response);
  }

  public async addManagementFee(payload: AddManagementFeesDto): Promise<ManagementFeeDto[]> {
    const url = `${BASE_URL}/add`;
    const response = await this.fetchWithAuth(url, {
      method: 'POST',
      body: JSON.stringify(payload),
    });
    return this.getJsonResponse(response);
  }

  public async deleteManagementFee(managementFeeId: string) {
    const url = `${BASE_URL}/${managementFeeId}`;
    await this.fetchWithAuth(url, {
      method: 'DELETE',
    });
  }

  public async getManagementFee(managementFeeId: string): Promise<ManagementFeeDto> {
    const url = `${BASE_URL}/${managementFeeId}`;
    const response = await this.fetchWithAuth(url);
    return this.getJsonResponse(response);
  }

  public async getManagementFeeCredits(filter?: GetManagementFeeCreditsParams): Promise<ManagementFeeCreditPaginationDto> {
    const url = urlWithQuery(`${BASE_URL}/credits`, filter);
    const response = await this.fetchWithAuth(url);
    return this.getJsonResponse(response);
  }

  public async addManagementFeeCredit(payload: AddManagementFeeCreditDto): Promise<ManagementFeeCreditDto> {
    const url = `${BASE_URL}/credits`;
    const response = await this.fetchWithAuth(url, {
      method: 'POST',
      body: JSON.stringify(payload),
    });
    return this.getJsonResponse(response);
  }

  public async getManagementFeeCredit(managementFeeCreditId: string): Promise<ManagementFeeCreditDto> {
    const url = `${BASE_URL}/credits/${managementFeeCreditId}`;
    const response = await this.fetchWithAuth(url);
    return this.getJsonResponse(response);
  }

  public async updateManagementFeeCredit(
    managementFeeCreditId: string,
    payload: AdjustManagementFeeCreditDto
  ): Promise<ManagementFeeCreditDto> {
    const url = `${BASE_URL}/credits/${managementFeeCreditId}`;
    const response = await this.fetchWithAuth(url, {
      method: 'PUT',
      body: JSON.stringify(payload),
    });
    return this.getJsonResponse(response);
  }

  public async deleteManagementFeeCredit(managementFeeCreditId: string) {
    const url = `${BASE_URL}/credits/${managementFeeCreditId}`;
    await this.fetchWithAuth(url, {
      method: 'DELETE',
    });
  }
}
